// extracted by mini-css-extract-plugin
module.exports = {"empty":"OXsHr","message":"DboXL","content":"JVzwh"};